import React, { Component } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./folder-animations.css"; // Archivo CSS para las animaciones de las carpetas
import EditIcon from "../../../assets/icons/edit-icon.svg";
import DropdownIcon from "../../../assets/icons/dropdown.svg";
import EllipseIcon from "../../../assets/icons/ellipse.svg";
import EditableText from "./EditableText";
import { Progress, Tooltip, Icon } from "antd";
import { injectIntl } from "react-intl";
import "./Folder.css";

export class Folder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true
    };
  }
  toggleExpand = files => {
    if (files) {
      const { expanded } = this.state;
      this.setState({
        expanded: !expanded
      });
    } else {
      const { onChangeReadOnlySelectInput, path } = this.props;
      onChangeReadOnlySelectInput(path);
    }
  };

  render() {
    const {
      name,
      files,
      path,
      onChangeReadOnly,
      readOnly,
      folderOrFile,
      intl,
      progressVisible,
      fromStep,
      onDelete,
      onDeleteFolder,
      onChangeName,
      onChangeReadOnlySelectInput
    } = this.props;
    const { expanded } = this.state;

    return (
      <div
        style={{
          marginBottom: "1%"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: "1%",
            alignItems: "center"
          }}
        >
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              alignItems: "center"
            }}
            onClick={() => this.toggleExpand(files)}
          >
            {files ? (
              <img
                src={DropdownIcon}
                alt="Dropdown"
                style={{
                  cursor: "pointer",
                  marginRight: "2%",
                  width: 12,
                  height: 12
                }}
              />
            ) : (
              <img
                src={EllipseIcon}
                alt="Ellipse"
                style={{
                  cursor: "pointer",
                  marginRight: "2%",
                  width: 5,
                  height: 5
                }}
              />
            )}
            <EditableText
              initialValue={name}
              readOnly={readOnly}
              isFolder={files}
              path={path}
              onChangeName={onChangeName}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "0 10px"
            }}
          >
            {!files &&
              this.props.onChangeReadOnly &&
              folderOrFile.state === "waiting" && (
                <img
                  src={EditIcon}
                  alt="Edit"
                  style={{ cursor: "pointer" }}
                  onClick={() => onChangeReadOnly(path)}
                />
              )}
            {folderOrFile.state === "inprogress" && (
              <Tooltip
                placement="top"
                title={intl.formatMessage({ id: "cancel_upload" })}
              >
                <Icon
                  type="close-circle"
                  className="folder-upload-icon"
                  onClick={() => {
                    if (this.props.handleAbort) {
                      this.props.handleAbort(folderOrFile);
                    }
                  }}
                />
              </Tooltip>
            )}
            {folderOrFile.state === "waiting" && (
              <Tooltip
                placement="top"
                title={intl.formatMessage({ id: "quit" })}
              >
                <Icon
                  type="delete"
                  className="folder-upload-icon"
                  onClick={() => {
                    onDelete(path);
                  }}
                />
              </Tooltip>
            )}
            {folderOrFile.state === "success" && (
              <Tooltip
                placement="top"
                title={intl.formatMessage({ id: "success_upload" })}
              >
                <Icon type="check-circle" className="folder-upload-icon" />
              </Tooltip>
            )}
            {folderOrFile.state === "error" && (
              <Tooltip
                placement="top"
                title={intl.formatMessage({ id: "error_upload" })}
              >
                <Icon
                  type="reload"
                  className="folder-upload-icon"
                  onClick={() => {
                    if (this.props.handleRetry) {
                      this.props.handleRetry(folderOrFile);
                    }
                  }}
                />
              </Tooltip>
            )}
            {/* <img src={DeleteIcon} alt = "Delete" style = {{cursor: "pointer"}} onClick={()=>onDelete(path)}/> */}
            {folderOrFile.state === "error" && (
              <Tooltip
                placement="top"
                title={intl.formatMessage({ id: "quit" })}
              >
                <Icon
                  type="delete"
                  className="folder-upload-icon"
                  onClick={() => {
                    if (this.props.handleRemoveFile) {
                      this.props.handleRemoveFile(folderOrFile);
                    }
                  }}
                />
              </Tooltip>
            )}
            {files && (
              <Tooltip
                placement="top"
                title={intl.formatMessage({ id: "quit" })}
              >
                <Icon
                  type="delete"
                  className="folder-upload-icon"
                  onClick={() => {
                    onDeleteFolder(name);
                  }}
                />
              </Tooltip>
            )}
          </div>
        </div>
        {progressVisible && (
          <Progress
            percent={folderOrFile.progress}
            size="small"
            status={
              folderOrFile.state === "inprogress"
                ? "active"
                : folderOrFile.state === "error"
                ? "exception"
                : "success"
            }
            strokeWidth={4}
            showInfo={false}
            style={{
              marginBottom: "1%"
            }}
          />
        )}
        <TransitionGroup>
          {expanded && (
            <CSSTransition key={name} classNames="folder" timeout={300}>
              <div className="subfolders">
                {files && (
                  <ul>
                    {files.map((subfolder, index) => {
                      return (
                        <Folder
                          key={subfolder.path}
                          name={subfolder.name}
                          folderOrFile={subfolder}
                          files={subfolder.files}
                          path={subfolder.path}
                          size={subfolder.size}
                          readOnly={subfolder.readOnly}
                          onChangeReadOnly={onChangeReadOnly}
                          progressVisible={
                            fromStep === 0 ? false : !subfolder.files
                          }
                          handleAbort={this.props.handleAbort}
                          onDelete={onDelete}
                          handleRetry={this.props.handleRetry}
                          intl={intl}
                          fromStep={fromStep}
                          onDeleteFolder={onDeleteFolder}
                          onChangeReadOnlySelectInput={
                            onChangeReadOnlySelectInput
                          }
                          onChangeName={onChangeName}
                        />
                      );
                    })}
                  </ul>
                )}
              </div>
            </CSSTransition>
          )}
        </TransitionGroup>
      </div>
    );
  }
}

export default injectIntl(Folder);
